/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { UserFragmentFragmentDoc } from './userFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CommentsByOrderQueryVariables = Exact<{
  orderReferenceId: string;
}>;


export type CommentsByOrderQuery = { comment: Array<{ content: string | null, deleted: boolean, id: string, created_date: string, modified_date: string, order_reference_id: string, user_id: string, reference_id: string, attachments: Array<{ domain: string, path: string, name: string | null }>, user: { id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null } }> };


export const CommentsByOrderDocument = /*#__PURE__*/ gql`
    query commentsByOrder($orderReferenceId: uuid!) {
  comment(
    order_by: {created_date: desc}
    where: {order_reference_id: {_eq: $orderReferenceId}}
  ) {
    content
    deleted
    id
    created_date
    attachments {
      domain
      path
      name
    }
    modified_date
    order_reference_id
    user_id
    reference_id
    user {
      ...userFragment
    }
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useCommentsByOrderQuery__
 *
 * To run a query within a React component, call `useCommentsByOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsByOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsByOrderQuery({
 *   variables: {
 *      orderReferenceId: // value for 'orderReferenceId'
 *   },
 * });
 */
export function useCommentsByOrderQuery(baseOptions: Apollo.QueryHookOptions<CommentsByOrderQuery, CommentsByOrderQueryVariables> & ({ variables: CommentsByOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsByOrderQuery, CommentsByOrderQueryVariables>(CommentsByOrderDocument, options);
      }
export function useCommentsByOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsByOrderQuery, CommentsByOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsByOrderQuery, CommentsByOrderQueryVariables>(CommentsByOrderDocument, options);
        }
// @ts-ignore
export function useCommentsByOrderSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommentsByOrderQuery, CommentsByOrderQueryVariables>): Apollo.UseSuspenseQueryResult<CommentsByOrderQuery, CommentsByOrderQueryVariables>;
export function useCommentsByOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsByOrderQuery, CommentsByOrderQueryVariables>): Apollo.UseSuspenseQueryResult<CommentsByOrderQuery | undefined, CommentsByOrderQueryVariables>;
export function useCommentsByOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsByOrderQuery, CommentsByOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentsByOrderQuery, CommentsByOrderQueryVariables>(CommentsByOrderDocument, options);
        }
export type CommentsByOrderQueryHookResult = ReturnType<typeof useCommentsByOrderQuery>;
export type CommentsByOrderLazyQueryHookResult = ReturnType<typeof useCommentsByOrderLazyQuery>;
export type CommentsByOrderSuspenseQueryHookResult = ReturnType<typeof useCommentsByOrderSuspenseQuery>;
export type CommentsByOrderQueryResult = Apollo.QueryResult<CommentsByOrderQuery, CommentsByOrderQueryVariables>;